"use client"

import { toast } from "sonner"
import RSSIcon from "@/components/core/icons/RssIcon"

export default function RSSButton({ path }: { path: `/${string}.xml` }) {
  const handleRss = () => {
    navigator.clipboard.writeText(window.location.origin + path)
    toast.success("Copied link to clipboard")
  }

  return (
    <button
      className="p-3 border border-grey-850 hover:bg-grey-850 w-12 h-12 rounded transition-all ease-in-out duration-100"
      onClick={handleRss}
    >
      <RSSIcon />
    </button>
  )
}
